import {IntegrationCard, IntegrationSectionHeader, IntegrationDeleteDialog} from '../IntegrationDesign';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Tooltip, IconButton} from "@mui/material";
import Spinner from "../../../spinner/Spinner";
import {DeleteOutlined, EditOutlined} from "@mui/icons-material";
import React, {useState} from "react";

function ServerIntegrations(props) {

    const {deleteIntegration, integration, history, location, clear} = props;

    const [prompt, setPrompt] = useState(false);
    const [deleteIntegrationId, setDeleteIntegrationId] = useState(0);

    const edit = (rowData) => {
        clear();
        if (rowData?.networkType === "server_aws") {
            history.push({
                pathname: "/settings/integrations/server-aws/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "server_cloudflare") {
            history.push({
                pathname: "/settings/integrations/server-cloudflare/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
        if (rowData?.networkType === "server_namesilo") {
            history.push({
                pathname: "/settings/integrations/server-namesilo/" + parseInt(rowData?.id),
                state: {background: location}
            });
        }
    };

    const addIntegration = () => {
        props.history.push({
            pathname: "/settings/integrations/add-server",
            state: {background: props.location}
        });
    };

    const handleDeletePrompt = (id) => {
        setDeleteIntegrationId(id);
        setPrompt(true);
    };

    const handleDeleteIntegration = (prompt) => {
        if (!prompt) {
            setPrompt(false);
            return false;
        } else {
            deleteIntegration(deleteIntegrationId);
            setPrompt(false);
        }
    };

    return (
        <Box sx={{minWidth: 0}}>
            <IntegrationCard elevation={0}>
                {integration?.loading?.serverIntegrations && <Spinner overComponentBox={true}/>}
                <IntegrationSectionHeader title="Servers & domains" description="Manage hosting, domain connections, and SSL certificates." onAdd={addIntegration}
                    count={integration?.loading?.serverIntegrations ? undefined : integration?.serverIntegrations?.length}/>

                {prompt &&
                    <IntegrationDeleteDialog question="Delete integration?" text={`Remove "${integration?.serverIntegrations?.find(row => row.id === deleteIntegrationId)?.networkName || 'this integration'}" from Skro?`} confirm={handleDeleteIntegration}/>
                }

                <TableContainer sx={{maxHeight: "400px"}}>
                    <Table stickyHeader size="small" aria-label="server-integrations">
                        <TableHead sx={{whiteSpace: "nowrap"}}>
                            <TableRow hover>
                                <TableCell>Name</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{whiteSpace: "nowrap"}}>
                            {integration?.serverIntegrations?.map((row) => (
                                <TableRow key={row?.id}>
                                    <TableCell sx={{width: "100%"}}>{row?.networkName}</TableCell>
                                    <TableCell>
                                        <Box display="flex" flexWrap="nowrap" alignItems="center"
                                             justifyContent="right">
                                            <Box mr={1}>
                                                <Tooltip title="Edit">
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        color="inherit"
                                                        onClick={() => edit(row)}
                                                        aria-label="edit"
                                                    >
                                                        <EditOutlined fontSize="small" color="inherit"/>
                                                    </IconButton>
                                                </span>
                                                </Tooltip>
                                            </Box>
                                            <Box>
                                                <Tooltip title="Delete">
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        color="inherit"
                                                        onClick={() => handleDeletePrompt(row?.id)}
                                                        aria-label="delete"
                                                    >
                                                        <DeleteOutlined fontSize="small" color="error"/>
                                                    </IconButton>
                                                </span>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </IntegrationCard>
        </Box>
    );

}

export default ServerIntegrations;
